export default __webpack_public_path__ + "static/media/ToolPreview.7cfdc4ac.png";